<template>
  <div class="reference-filter">
    <reference-filter-header
      :label="label"
      :expanded="expanded"
      :count="count"
      @click="expanded = !expanded"
    />
    <div
      ref="content"
      class="content"
      :class="{ expanded }"
      :style="{ maxHeight }"
    >
      <v-divider />
      <div ref="fields" class="field-grid pa-4">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { ResizeObserver } from '@juggle/resize-observer';
import ReferenceFilterHeader from './ReferenceFilterHeader';

export default {
  name: 'ReferenceFilter',
  components: { ReferenceFilterHeader },
  props: {
    label: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    expanded: false,
    contentHeight: null,
  }),
  computed: {
    maxHeight() {
      const content = this.$refs.content || {};
      const height = this.contentHeight || content.scrollHeight || 0;
      return this.expanded ? `${height}px` : 0;
    },
  },
  mounted() {
    this.onContentResize();
    this.$nextTick(() => {
      this.resizeObserver = new ResizeObserver(this.onContentResize);
      this.resizeObserver.observe(this.$refs.fields);
    });
  },
  methods: {
    onContentResize() {
      this.contentHeight = this.$refs.content?.scrollHeight;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/styles.sass';

.reference-filter {
  background-color: white;

  .content {
    overflow: hidden;

    transition: max-height 0.2s ease-in-out;

    .field-grid {
      display: grid;
      grid-gap: 16px;
    }
  }
}
</style>
